import { Container, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

export default function WaitingRoom() {
  const { profile } = useAuth();

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>
        Registration pending
      </Typography>
      <Typography>
        Thanks {profile?.full_name || "Tutor"} — your account is waiting for
        approval. Once an admin approves you, you'll get access to your Tutor
        Dashboard.
      </Typography>
    </Container>
  );
}
